import { render } from "./pageaddheader.vue?vue&type=template&id=8f35ef46"
import script from "./pageaddheader.vue?vue&type=script&lang=js"
export * from "./pageaddheader.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zonegoh/Documents/GitHub/levelup/level-up/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__